import React, { useState, useEffect } from "react";
import app from "nystem";
import { ContentTypeRender, Wrapper, useUser } from "nystem-components";

const firstValue = (value) => (value instanceof Array ? value[0] : value);

const getFailURL = ({ data, view }) => {
  const program = firstValue(
    view.baseView?.getValue("_id") ||
      view.getValue("program") ||
      view.baseView?.getValue("program"),
  );
  const path = program
    ? `/program/details/${program}/fail`
    : `${window.location.pathname.replace(
        /\/(success|fail|subscribe).*$/,
        "",
      )}/fail`;
  const error = encodeURIComponent(data.refusalReason || "");

  return error ? `${path}?error=${error}` : path;
};

const ViewButtonBuyButton = ({ view, model, value, path }) => {
  const { className } = model;
  const user = useUser();

  const [state, setState] = useState("item");

  useEffect(() => {
    const handleSubmit = async ({ errors = [] } = {}) => {
      if (!errors.length) ({ errors = [] } = await view.event("validate"));

      if (errors.length) return;

      setState("itemSending");
      const { data, error } = await app.database[view.contentType].save({
        data: { ...value },
        view: view.format,
      });

      if (app.settings.debug) console.log("zzave", { data, error }, value._id);

      if (error) {
        view.event("error", error);
        return;
      }

      const saved = await view.event("save", data);
      view.setValue({ value: saved });
      if (saved.status === "failed")
        window.history.replaceState({}, "", getFailURL({ data: saved, view }));
    };

    view.on("submit", handleSubmit);

    return () => {
      view.off("submit", handleSubmit);
    };
  }, [model, value, view]);

  useEffect(() => {
    if (user?.cardError) {
      setState("item");
      return;
    }
    if (!user?.card) return;
    if (value.status !== "active") return;

    setState("done");
  }, [user, value.status]);

  useEffect(() => {
    const setBuybuttonState = ({ state }) => {
      setState(state);
    };
    view.on("setBuybuttonState", setBuybuttonState);
    return () => {
      view.on("setBuybuttonState", setBuybuttonState);
    };
  }, [view]);

  useEffect(() => {
    if (!user?.card) return;
    app.delay(100).then(async () => {
      const { data } = await app.database[view.contentType].search({
        filter: { user: user._id, $and: [{ status: "pending" }] },
      });
      if (!data) return;
      const at = data.find((item) => {
        if (item._crdate < Date.now() - 1000 * 60 * 60) {
          app.database[view.contentType].save({
            data: { ...item, status: "failed" },
          });
          return false;
        }
        return true;
      });

      if (!at) return;
      await view.setValue({ value: at });
      app.database[view.contentType].save({
        data: { _id: at._id, status: "active" },
        first: true,
        fields: true,
      });
    });
  }, [user, view]);

  useEffect(() => {
    if (!value._id) return;
    const update = async ({ ids }) => {
      if (ids && !ids.includes(value._id)) return;

      const { data } = await app.database[view.contentType].get({
        id: value._id,
      });
      await app.delay(300);
      view.setValue({ value: data });
      if (data.status === "failed") {
        window.history.replaceState({}, "", getFailURL({ data, view }));
      } else if (data.status === "active") setState("done");
    };
    app.database[view.contentType].on("update", update);
    return () => {
      app.database[view.contentType].off("update", update);
    };
  }, [value._id, view]);

  if (!value.product) return null;

  return (
    <Wrapper
      className={className}
      onClick={state === "item" ? () => view.event("submit") : undefined}
    >
      <ContentTypeRender path={path} items={model[state]} />
    </Wrapper>
  );
};

export default ViewButtonBuyButton;
